import Typography from '@mui/material/Typography';
import { styled } from '@mui/material/styles';
import {Paper} from "@mui/material";
import {Grid} from "@mui/system";
import DateBox from "./DateBox";
import InfoBox from "./InfoBox";
import Button from "@mui/material/Button";
import {addToCalendar, isDateToday, orange} from "../utils";
import {CalendarIcon} from "@mui/x-date-pickers";
import React from "react";
import Box from "@mui/material/Box";

const DemoPaper = styled(Paper)(({ theme }) => ({
    marginBottom: theme.spacing(2),
    minWidth: 275,
    background:'#faf8f5 none repeat scroll 0 0',
    paddingRight: theme.spacing(2),
    ...theme.typography.body2,
    textAlign: 'center',
}));

export default function EventCard({event, showLocation}) {

    const isToday = React.useMemo(() => {
        return isDateToday(event.date);
    }, [event.date]);

    return (
        <DemoPaper
            square={false}
            variant="outlined"
            style={{borderRadius: "10px"}}
            sx={{ display: {xs: 'none', sm: 'none', md: 'block', lg: 'block', xl: 'block', }}}
        >
            <Grid container spacing={0}>
                <Grid size={1} sx={{alignContent: 'baseline', maxWidth: '80px', marginTop:'20px'}}>
                    <DateBox date={new Date(event.startDate)} isToday={isToday} />
                </Grid>
                <Grid size={3} sx={{alignContent: 'baseline', paddingLeft: 1, paddingRight: 1}}>
                    <InfoBox event={event} showLocation={showLocation} isToday={isToday}/>
                </Grid>
                <Grid size={6} sx={{alignContent: 'baseline',paddingTop:'15px', flexGrow: 1, borderLeft: "1px solid rgba(0, 0, 0,0.2)"}}>
                    <Box sx={{textAlign: 'left', paddingLeft: 2,}}>
                        <Typography variant="h6" component="h4" style={{fontWeight: '600', fontSize: "1.1rem", color: "#303969", fontFamily: "inherit",letterSpacing: "0.06rem"}}>
                            {event.eventName}
                        </Typography>
                        <div style={{fontSize: "0.9rem", color: "black", letterSpacing: "1px", lineHeight: "2", marginTop: "15px", marginBottom:"15px"}} dangerouslySetInnerHTML={{ __html: event.description }} />
                    </Box>
                </Grid>
                <Grid size={2} sx={{alignContent: 'baseline', maxWidth: "200px", marginTop:'20px'}}>
                    <Button
                        variant="outlined"
                        onClick={() => addToCalendar(event)}
                        startIcon={<CalendarIcon />}
                        style={{border: "none", color: isToday ? orange[500]: "#000000", fontWeight: "bold",}}
                    >
                        {"Add to calender"}
                    </Button>
                </Grid>
            </Grid>
        </DemoPaper>
    );
}